import Reveal from "../components/Reveal";
import { Link } from "react-router-dom";
import { IMG } from "../data/content";
import { openEnquiry } from "../components/Header";

export default function Stay() {
  return (
    <section id="stay" data-testid="stay-section" className="mx-auto max-w-7xl scroll-mt-20 px-6 py-24 sm:px-12 sm:py-32 lg:px-20 lg:py-40">
      <div className="grid items-center gap-14 lg:grid-cols-2 lg:gap-20">
        <Reveal className="group relative order-2 overflow-hidden lg:order-1">
          <img
            data-testid="stay-image"
            src={IMG.lodgePanoTall}
            alt="The tents of The Jamoon set within deep forest beside the Ramganga"
            loading="lazy"
            className="aspect-[4/5] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-charcoal/50 to-transparent" />
          <p className="absolute bottom-5 left-5 text-[11px] tracking-[0.25em] text-ivory/80">
            FIVE TENTS · TEN ACRES OF FOREST
          </p>
        </Reveal>
        <div className="order-1 lg:order-2">
          <Reveal>
            <p className="text-xs font-medium uppercase tracking-[0.3em] text-brass">Stay</p>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-6 font-serif text-3xl font-light leading-tight tracking-tight text-ivory sm:text-4xl lg:text-5xl">
              <Link data-testid="home-stay-page-link" to="/stay" className="text-inherit no-underline">
                Stay in <span className="italic text-brass">the wild.</span>
              </Link>
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-8 max-w-lg text-base font-light leading-relaxed text-ivory/75 sm:text-lg">
              The Jamoon keeps only a handful of tents across ten acres of forest floor, a
              short walk from the Ramganga. Nights are lit by solar lamps; the soundtrack is
              the forest itself.
            </p>
            <p className="mt-5 max-w-lg text-sm leading-relaxed text-ivory/55 sm:text-base">
              Every tent has an attached washroom with running water — comfort, kept quiet.
              Nothing here competes with where you are.
            </p>
          </Reveal>
          <Reveal delay={0.3}>
            <button
              data-testid="stay-enquire-btn"
              onClick={openEnquiry}
              className="mt-9 border border-brass/50 px-7 py-3.5 text-xs font-semibold tracking-[0.25em] text-brass transition-colors duration-500 hover:bg-brass hover:text-charcoal"
            >
              ENQUIRE ABOUT A TENT
            </button>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
